import { render, staticRenderFns } from "./NapTransferRequests.vue?vue&type=template&id=0efe70e9&scoped=true&"
import script from "./NapTransferRequests.vue?vue&type=script&lang=js&"
export * from "./NapTransferRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efe70e9",
  null
  
)

export default component.exports